//#region Imports

import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { ButtonRadiusEnum } from '../button/types/button-radius.enum';
import { ButtonSizeEnum } from '../button/types/button-size.enum';
import { ButtonTypeEnum } from '../button/types/button-type.enum';
import { IconComponent } from '../icon/icon.component';
import { LoadingBarComponent } from '../loading-bar/loading-bar.component';
import {
  FileUploadStatus,
  FileUploadUploadedActions,
} from './file-upload-status.type';

//#endregion

@Component({
  selector: 'l-file-upload-dropzone',
  standalone: true,
  templateUrl: './file-upload-dropzone.component.html',
  styleUrl: './file-upload-dropzone.component.scss',
  imports: [ButtonComponent, IconComponent, LoadingBarComponent],
})
export class FileUploadDropzoneComponent {

  //#region Public Properties

  @Input()
  public status: FileUploadStatus = 'idle';

  @Input()
  public fileName: string = '';

  @Input()
  public fileSizeLabel: string = '';

  @Input()
  public accept: string = '';

  @Input()
  public inputId: string = '';

  @Input()
  public dashedBorder: boolean = true;

  @Input()
  public idleTitle: string = 'Selecione o arquivo para upload';

  @Input()
  public idleHints: string[] = [];

  @Input()
  public uploadingTitle: string = 'Carregando arquivo...';

  @Input()
  public uploadingHints: string[] = [
    'A operação está em andamento.',
    'Não feche esta página até que ela seja concluída.',
  ];

  @Input()
  public uploadedTitle: string = 'Arquivo enviado!';

  @Input()
  public selectButtonLabel: string = 'Selecionar arquivo';

  @Input()
  public replaceButtonLabel: string = 'Reenviar';

  @Input()
  public uploadedActions: FileUploadUploadedActions = 'replace-only';

  @Output()
  public readonly fileSelected: EventEmitter<Event> = new EventEmitter<Event>();

  @Output()
  public readonly deleteClick: EventEmitter<void> = new EventEmitter<void>();
  
  @ViewChild('fileInput')
  public readonly fileInput?: ElementRef<HTMLInputElement>;

  public readonly buttonTypeEnum = ButtonTypeEnum;

  public readonly buttonRadiusEnum = ButtonRadiusEnum;

  public readonly buttonSizeEnum = ButtonSizeEnum;

  //#endregion

  //#region Getters

  public get actionButtonLabel(): string {
    return this.status === 'uploaded' ? this.replaceButtonLabel : this.selectButtonLabel;
  }

  //#endregion

  //#region Public Methods

  public openFilePicker(): void {
    this.fileInput?.nativeElement.click();
  }

  public onFileInputChange(event: Event): void {
    this.fileSelected.emit(event);
  }

  public onDeleteClick(): void {
    this.deleteClick.emit();
  }

  //#endregion

}
